module.exports = __webpack_public_path__ + "img/new_com.694cdeed.png";